/**
 * UserLocationDTO
 * 
    {
        "countryCode" : string,
        "countryCodeVerifiedTimestamp" : ConnectTimestamp,
        "userProfileId" : integer,
        "countryCodeVerified" : boolean
    }
 */
import Backbone from 'backbone';

var UserLocation = Backbone.Model.extend({
    backend: 'gcapi',

    url: function() {
        return '/userprofile-service/userprofile/location';
    }
});

export default UserLocation;
